export const INITIAL_VALUES = {
  schoolId: null,
  organization: '',
  stateAbbreviation: '',
  phoneNumber: '',
  city: '',
  isSchoolAdmin: false
};
